<template>
  <div>
    <ProformDataHead
      :countFilterParams="countFilterParams"
      :showFilter="showFilter"
      @toggleFilter="toggleFilter"
      @updateTable="$emit('updateTable')"
      @changeTab="index => $emit('changeTab', index)"
      :tabs="tabs"
    />

    <div class="table-filter-wrap">

      <ProformDataFilter
          :showFilter="showFilter"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
          :filterGetParams="filterGetParams"
      />

      <ProformDataTable
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @updateTable="$emit('updateTable')"
          :countFilterParams="countFilterParams"
      />
    </div>
  </div>
</template>

<script>


  import ProformDataHead from "./ProformDataHead/ProformDataHead";
  import ProformDataTable from "./ProformDataTable/ProformDataTable";
  import ProformDataFilter from "./ProformDataFilter/ProformDataFilter";

  export default {
    name: "ProformDataTableAdmin",

    components: {
      ProformDataHead,
      ProformDataTable,
      ProformDataFilter,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
      tabs: Array,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeShopType(index) {
        this.$emit('changeShopType', index)
      },


      changeFilter(data) {
        this.$emit('changeFilter', data)
      },


      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
